/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useNavigate } from 'react-router-dom';
import { ApiRequest } from '../../services/api';

const CustomRecipeTableRow = ({ item, onDeleteSuccess }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleEdit = () => {
    // console.log("Editar:", item); // Imprime el elemento en la consola
    navigate(`/Dashboard/Recetas/Edit/${item.id}`);
    setAnchorEl(null); // Cierra el menú
  };

  const handleDelete = async () => {
        const confirmDelete = window.confirm("¿Estás seguro de que deseas eliminar esta receta? Esta acción no se puede deshacer.");
      
        if (!confirmDelete) {
          setAnchorEl(null);
          return; // Si el usuario cancela, no se ejecuta la eliminación
        }
      
        // console.log("Eliminar:", item); // Imprime el elemento en la consola
        try {
          const response = await ApiRequest('api/Recetas/Eliminar', 'DELETE', {
            RecetaId: item.id,
          });
      
          if (response) {
            alert('Receta eliminada con éxito');
            navigate('/Dashboard/Recetas'); 
            onDeleteSuccess();
          } else {
            console.error('Error al eliminar la receta');
          }
        } catch (error) {
          console.error('Error al hacer la solicitud:', error);
        } finally {
          setAnchorEl(null); // Cierra el menú
        }
      };

  return (
    <tr key={item.id}>
      <td>{item.nombre}</td>
      
      <td>{item.estatus}</td>
      <td align="center">
        <div>
          {item.urlImagen ? (
            <span style={{ color: "green" }}>✓</span>
          ) : (
            <span style={{ color: "red" }}>✗</span>
          )}
        </div>
      </td>

      <br></br>
      <br></br>
      {/* Icono de tres puntos */}
      
      <td>
        {/**/}
        <IconButton onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
          <MenuItem onClick={handleEdit}>Editar</MenuItem>
          <MenuItem onClick={handleDelete}>Eliminar</MenuItem>
        </Menu>
        {/**/}
      </td>
    </tr>
  );
};

export default CustomRecipeTableRow;
